var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false, design: "v3" },
      on: { cancel: _vm.cancel },
    },
    [
      _c("div", { staticClass: "extra-plan-content" }, [
        _c("div", { staticClass: "header-section" }, [
          _c("div", { staticClass: "icon-wrapper" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("shopping_cart"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v("Ekstra Chatbot Satın Al"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v("İhtiyacınıza uygun session paketini seçin"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "suggestion-sessions" }, [
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 1000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 1000
                },
              },
            },
            [_vm._v("\n                1K\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 5000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 5000
                },
              },
            },
            [_vm._v("\n                5K\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 10000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 10000
                },
              },
            },
            [_vm._v("\n                10K\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 20000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 20000
                },
              },
            },
            [_vm._v("\n                20K\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 50000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 50000
                },
              },
            },
            [_vm._v("\n                50K\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 100000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 100000
                },
              },
            },
            [_vm._v("\n                100K\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 250000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 250000
                },
              },
            },
            [_vm._v("\n                250K\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 1000000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 1000000
                },
              },
            },
            [_vm._v("\n                1M\n            ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "custom-input-section" }, [
          _c("div", { staticClass: "input-container" }, [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("div", { staticClass: "input-icon" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("edit")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-content" },
                [
                  _c("div", { staticClass: "input-label" }, [
                    _vm._v("Özel Session Miktarı"),
                  ]),
                  _vm._v(" "),
                  _c("a-input-number", {
                    staticClass: "custom-input",
                    attrs: {
                      min: 1,
                      max: 10000000,
                      placeholder: "Miktar girin",
                    },
                    model: {
                      value: _vm.sessionCount,
                      callback: function ($$v) {
                        _vm.sessionCount = $$v
                      },
                      expression: "sessionCount",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "arrow-separator" }, [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("arrow_forward"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "price-wrapper" }, [
              _c("div", { staticClass: "price-label" }, [
                _vm._v("Toplam Fiyat"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "price-value" },
                [
                  _c("MoneyFormatter", {
                    attrs: {
                      price: _vm.totalPrice,
                      className: _vm.total - _vm.price,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.sessionCount > 0
          ? _c("div", { staticClass: "warning-message" }, [
              _c("div", { staticClass: "warning-icon" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "warning-content" }, [
                _c("div", { staticClass: "warning-title" }, [
                  _vm._v("Önemli Bilgi"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "warning-text" }, [
                  _vm._v("\n                    Paketiniz "),
                  _c("strong", [_vm._v(_vm._s(_vm.endOfMonthDate))]),
                  _vm._v(
                    " tarihinde sonlanacaktır ve ücret kesintisi\n                    hemen yapılacaktır.\n                "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c(
              "SupsisButton",
              {
                staticClass: "footer-btn cancel-btn",
                on: { click: _vm.cancel },
              },
              [_vm._v("İptal")]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                staticClass: "footer-btn primary-btn",
                attrs: { primary: "", disabled: _vm.sessionCount <= 0 },
                on: { click: _vm.confirm },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("check_circle"),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("Satın Al")]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }